
import axios from 'axios'



function auth(customer, email, password, reCaptcha) {
    return axios.post(`${process.env.VUE_APP_APIURL}/auth/customer`, {domain:customer, email, password, reCaptcha})
        .then(resp => {
            axios.defaults.headers.common['token'] = resp.data.token
            return resp.data
        })
}

function verifyMFA(trnxId, code, reCaptcha) {
    return axios.post(`${process.env.VUE_APP_APIURL}/auth/customer/verify-mfa`, {trnxId, code, reCaptcha})
        .then(resp => {
            axios.defaults.headers.common['token'] = resp.data.token
            return resp.data
        })
}

function updateUserGuidingShown(boolean) {
    return axios.put(`${process.env.VUE_APP_APIURL}/me/user-guiding-shown`, { userGuidingShown: boolean })
        .then(resp => {
            return resp.data
        })
}
function getCustomer(customer) {
    return axios.get(`${process.env.VUE_APP_APIURL}/customer/${customer}`)
        .then(resp => {
            return resp.data
        })
}
function getCustomerSummary(domain) {
    return axios.get(`${process.env.VUE_APP_APIURL}/customer/${domain}/summary`)
        .then(resp => {
            return resp.data
        })
}

function getGateways() {
    return axios.get(`${process.env.VUE_APP_APIURL}/gateway`)
        .then(resp => {
            return resp.data
        })
}
export default {
    auth,
    verifyMFA,
    getCustomer,
    getGateways,
    updateUserGuidingShown,
    getCustomerSummary
};